import { isEmpty } from 'lodash';
import React, { useMemo } from 'react';

import { FormikSelectOption, QueryFilters, QuerySorting } from 'components';
import { OrdersTab } from 'enums';
import { useUser } from 'hooks';
import { FilterDefinition } from 'types';

import { ExportPayinOrders } from '../ExportOrders';

type Props = {
  tab: OrdersTab;
  queryResult: any;
  filtersDefinitions: FilterDefinition[];
  sortingFields: FormikSelectOption[];
};

export const OrdersActions: React.FC<Props> = ({
  tab,
  queryResult,
  filtersDefinitions,
  sortingFields,
}) => {
  const { isAdmin, isTechOperator, isTrader, isMerchant } = useUser();
  const exportEnabled = useMemo(() => {
    if (isEmpty(queryResult.data?.items)) {
      return false;
    }
    if (tab === OrdersTab.RequisitesVerification) {
      return false;
    }
    return (
      isAdmin ||
      isTechOperator ||
      isTrader ||
      (isMerchant && tab === OrdersTab.All)
    );
  }, [isAdmin, isTechOperator, isTrader, isMerchant, queryResult, tab]);

  return (
    <div className="tw-flex tw-items-center tw-justify-end">
      <div className="tw-flex-1">
        <QueryFilters filtersDefinitions={filtersDefinitions} />
      </div>
      {!isEmpty(sortingFields) && (
        <QuerySorting sortingFields={sortingFields} />
      )}
      {exportEnabled && <ExportPayinOrders tab={tab} />}
    </div>
  );
};
